import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Page } from "src/app/shared/models/paging/page";
import { PagedData } from "src/app/shared/models/paging/paged-data";
import { ReturnResult } from "src/app/shared/models/return-result";
import { environment } from "src/environments/environment";
import { GenerateLeaveEntitlementModel, LeaveEntitlementModel, LeaveEntitlementViewModel } from "./leave-entitlement-management.model";

@Injectable({
    providedIn: 'root'
})

export class LeaveEntitlementManagamentService {
    baseUrl = environment.apiLeaveManagement;
    constructor(private http: HttpClient) { }

    getLeaveEntitlementPaging(page: Page): Observable<ReturnResult<PagedData<LeaveEntitlementModel | any>>> {
        return this.http.post<ReturnResult<PagedData<LeaveEntitlementModel>>>(`${this.baseUrl}/getLeaveEntitlement`, page);
    }

    saveLeaveEntitlement(model: LeaveEntitlementModel): Observable<ReturnResult<LeaveEntitlementModel>> {
        return this.http.post<ReturnResult<LeaveEntitlementModel>>(`${this.baseUrl}/SaveLeaveEntitlement`, model);
    }

    deleteLeaveEntitlement(id: string): Observable<ReturnResult<boolean>> {
        return this.http.delete<ReturnResult<boolean>>(`${this.baseUrl}/DeleteLeaveEntitlement/${id}`);
    }

    deleteLeaveEntitlements(id: number[]): Observable<ReturnResult<boolean>> {
        return this.http.post<ReturnResult<boolean>>(`${this.baseUrl}/DeleteLeaveEntitlements`, id);
    }

    getLeaveEntitlementById(employeeId: string) {
        return this.http.get<ReturnResult<LeaveEntitlementModel[]>>(`${this.baseUrl}/GetLeaveEntitlementById?employeeId=${employeeId}`);
    }

    getLeaveEntitlementByIdToTransfer(employeeId: string) {
        return this.http.get<ReturnResult<LeaveEntitlementModel[]>>(`${this.baseUrl}/GetLeaveEntitlementByIdToTransfer?employeeId=${employeeId}`);
    }

    getAllLeaveEntitlementById(leaveEntitlementId: number) {
        return this.http.get<ReturnResult<LeaveEntitlementModel[]>>(`${this.baseUrl}/GetAllLeaveEntitlementById?leaveEntitlementId=${leaveEntitlementId}`);
    }

    getYearOfLeaveEntitlement() {
        return this.http.get<ReturnResult<number[]>>(`${this.baseUrl}/GetYearOfLeaveEntitlement`);
    }

    getTotalLeaveEntitlementById(employeeId: string) {
        return this.http.get<ReturnResult<LeaveEntitlementViewModel>>(`${this.baseUrl}/GetTotalLeaveEntitlementById?employeeId=${employeeId}`);
    }

    generateLeaveEntitlement(model: GenerateLeaveEntitlementModel): Observable<ReturnResult<boolean>> {
        return this.http.post<ReturnResult<boolean>>(`${this.baseUrl}/GenerateLeaveEntitlement`, model);
    }
}